import _ from 'lodash'
import React from 'react'

import type { UI2TemperatureFieldProps } from 'shared-libs/components/ui2/fields/ui2-temperature-field/ui2-temperature-field-props'

import { UI2QuantityField } from '../ui2-quantity-field/ui2-quantity-field'

type UnitOption = { label: string; value: string }

const TEMPERATURE_UNIT_LABELS: Record<string, string> = {
  Fahrenheit: '°F',
  Celsius: '°C',
  Kelvin: 'K',
}

const DEFAULT_UNIT_OPTIONS: UnitOption[] = [{ label: '°F', value: 'Fahrenheit' }]

function isQuantityObject(val: any): val is { unit?: string; value?: number } {
  return val !== null && val !== undefined && typeof val === 'object' && 'value' in val
}

function getUnitLabel(unitValue: string): string {
  return TEMPERATURE_UNIT_LABELS[unitValue] ?? unitValue
}

/**
 * @uiComponent
 */
export interface IUI2TemperatureFieldProps extends UI2TemperatureFieldProps {
  onChange?: (value: any) => void
  errors?: any[]
  /** Entity frames context — used to resolve unit options from the bound schema. */
  frames?: any
}

export class UI2TemperatureField extends React.Component<IUI2TemperatureFieldProps> {
  private getDataSchema(): any {
    const { frames } = this.props
    return frames?.getContext?.('dataSchema')
  }

  private isObjectPath(): boolean {
    const schema = this.getDataSchema()
    if (schema?.type === 'object') return true
    if (schema?.type) return false
    return isQuantityObject(this.props.value)
  }

  private getResolvedUnitOptions(): UnitOption[] {
    const { unitOptions } = this.props
    if (unitOptions?.length) return unitOptions as UnitOption[]
    if (this.isObjectPath()) {
      const schema = this.getDataSchema()
      const unitSchema = _.get(schema, 'properties.unit')
      const enumOptions: UnitOption[] | undefined = unitSchema?.enumOptions
      if (enumOptions?.length) return enumOptions
      const fromList: string[] | undefined = unitSchema?.enum?.length
        ? unitSchema.enum
        : unitSchema?.suggestions
      if (fromList?.length) {
        return fromList.map((v) => ({ label: getUnitLabel(v), value: v }))
      }
    }
    return DEFAULT_UNIT_OPTIONS
  }

  private handleChange = (next: any): void => {
    const { onChange } = this.props
    if (!onChange) return
    if (this.isObjectPath()) {
      onChange(next)
      return
    }
    if (isQuantityObject(next)) {
      onChange(next.value)
    } else {
      onChange(next)
    }
  }

  public render() {
    const { placeholder, label } = this.props
    const resolvedPlaceholder = placeholder ?? (label?.trim() ? `Enter ${label.trim()}` : 'Enter value')
    return (
      <UI2QuantityField
        {...this.props}
        placeholder={resolvedPlaceholder}
        unitOptions={this.getResolvedUnitOptions()}
        onChange={this.handleChange}
      />
    )
  }
}
